import { render, staticRenderFns } from "./ChechboxButtonsWrapper.vue?vue&type=template&id=20cbf96a&scoped=true&"
import script from "./ChechboxButtonsWrapper.vue?vue&type=script&lang=js&"
export * from "./ChechboxButtonsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ChechboxButtonsWrapper.vue?vue&type=style&index=0&id=20cbf96a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cbf96a",
  null
  
)

export default component.exports